import LargeAlarmClockIcon from './large/alarm_clock.svg?react'
import LargeBankCardIcon from './large/bank-card.svg?react'
import LargeBankIcon from './large/bank.svg?react'
import LargeBedIcon from './large/bed.svg?react'
import LargeBellOffIcon from './large/bell-off.svg?react'
import LargeBellIcon from './large/bell.svg?react'
import LargeBoneIcon from './large/bone.svg?react'
import LargeBookIcon from './large/book.svg?react'
import LargeBoxIcon from './large/box.svg?react'
import LargeBriefcaseIcon from './large/briefcase.svg?react'
import LargeBuildingsIcon from './large/buildings.svg?react'
import LargeCalculatorIcon from './large/calculator.svg?react'
import LargeCalendar2Icon from './large/calendar-2.svg?react'
import LargeCalendarAlarmClockIcon from './large/calendar-alarm-clock.svg?react'
import LargeCalendarArrowLeftIcon from './large/calendar-arrow-left.svg?react'
import LargeCalendarArrowRightIcon from './large/calendar-arrow-right.svg?react'
import LargeCalendarCheckIcon from './large/calendar-check.svg?react'
import LargeCalendarClock2Icon from './large/calendar-clock-2.svg?react'
import LargeCalendarClock3Icon from './large/calendar-clock-3.svg?react'
import LargeCalendarClockIcon from './large/calendar-clock.svg?react'
import LargeCalendarDollarIcon from './large/calendar-dollar.svg?react'
import LargeCalendarMinusIcon from './large/calendar-minus.svg?react'
import LargeCalendarPlusIcon from './large/calendar-plus.svg?react'
import LargeCalendarRefreshIcon from './large/calendar-refresh.svg?react'
import LargeCalendarIcon from './large/calendar.svg?react'
import LargeCalendarsIcon from './large/calendars.svg?react'
import LargeCameraIcon from './large/camera.svg?react'
import LargeCapIcon from './large/cap.svg?react'
import LargeCarIcon from './large/car.svg?react'
import LargeCardReaderIcon from './large/card-reader.svg?react'
import LargeCardsIcon from './large/cards.svg?react'
import LargeCheckmarkIcon from './large/checkmark.svg?react'
import LargeChevronDownIcon from './large/chevron-down.svg?react'
import LargeChevronLeftIcon from './large/chevron-left.svg?react'
import LargeChevronRightIcon from './large/chevron-right.svg?react'
import LargeChevronUpIcon from './large/chevron-up.svg?react'
import LargeChevronsDownIcon from './large/chevrons-down.svg?react'
import LargeClipboardIcon from './large/clipboard.svg?react'
import LargeClockLockIcon from './large/clock-lock.svg?react'
import LargeClockIcon from './large/clock.svg?react'
import LargeClose2Icon from './large/close-2.svg?react'
import LargeCloseIcon from './large/close.svg?react'
import LargeCogIcon from './large/cog.svg?react'
import LargeCoins2Icon from './large/coins-2.svg?react'
import LargeCoins3Icon from './large/coins-3.svg?react'
import LargeCoinsHandIcon from './large/coins-hand.svg?react'
import LargeCoinsIcon from './large/coins.svg?react'
import LargeComputerCheckmarkIcon from './large/computer-checkmark.svg?react'
import LargeComputerClockIcon from './large/computer-clock.svg?react'
import LargeComputerDollarIcon from './large/computer-dollar.svg?react'
import LargeComputerMessageIcon from './large/computer-message.svg?react'
import LargeCopyIcon from './large/copy.svg?react'
import LargeCornerUpRightIcon from './large/corner-up-right.svg?react'
import LargeCrownIcon from './large/crown.svg?react'
import LargeDiamondIcon from './large/diamond.svg?react'
import LargeDiscountIcon from './large/discount.svg?react'
import LargeDocument2Icon from './large/document-2.svg?react'
import LargeDocumentClockIcon from './large/document-clock.svg?react'
import LargeDocumentLockIcon from './large/document-lock.svg?react'
import LargeDocumentPenIcon from './large/document-pen.svg?react'
import LargeDollar2Icon from './large/dollar-2.svg?react'
import LargeDollar3Icon from './large/dollar-3.svg?react'
import LargeDollar4Icon from './large/dollar-4.svg?react'
import LargeDollar5Icon from './large/dollar-5.svg?react'
import LargeDollar6Icon from './large/dollar-6.svg?react'
import LargeDollar7Icon from './large/dollar-7.svg?react'
import LargeDollar9Icon from './large/dollar-9.svg?react'
import LargeDollarIcon from './large/dollar.svg?react'
import LargeDragIcon from './large/drag.svg?react'
import LargeDropboxIcon from './large/dropbox.svg?react'
import LargeEmployeeCardIcon from './large/employee-card.svg?react'
import LargeEnvelopeClockIcon from './large/envelope-clock.svg?react'
import LargeEnvelopeIcon from './large/envelope.svg?react'
import LargeExclamationIcon from './large/exclamation.svg?react'
import LargeExternalLinkIcon from './large/external-link.svg?react'
import LargeEyeOffIcon from './large/eye-off.svg?react'
import LargeEyeIcon from './large/eye.svg?react'
import LargeFaceFrownIcon from './large/face-frown.svg?react'
import LargeFaceSmileIcon from './large/face-smile.svg?react'
import LargeField2Icon from './large/field-2.svg?react'
import LargeFieldIcon from './large/field.svg?react'
import LargeFileIcon from './large/file.svg?react'
import LargeFilterIcon from './large/filter.svg?react'
import LargeFlagIcon from './large/flag.svg?react'
import LargeFloppyDiskIcon from './large/floppy-disk.svg?react'
import LargeFolderPenIcon from './large/folder-pen.svg?react'
import LargeFolderIcon from './large/folder.svg?react'
import LargeForm2Icon from './large/form-2.svg?react'
import LargeFormIcon from './large/form.svg?react'
import LargeGiftIcon from './large/gift.svg?react'
import LargeGlobe2Icon from './large/globe-2.svg?react'
import LargeGlobeClockIcon from './large/globe-clock.svg?react'
import LargeGlobeIcon from './large/globe.svg?react'
import LargeGoogleDriveIcon from './large/google-drive.svg?react'
import LargeGoogleIcon from './large/google.svg?react'
import LargeGraph2Icon from './large/graph-2.svg?react'
import LargeGraphIcon from './large/graph.svg?react'
import LargeGrid2Icon from './large/grid-2.svg?react'
import LargeGridIcon from './large/grid.svg?react'
import LargeHandIcon from './large/hand.svg?react'
import LargeHashIcon from './large/hash.svg?react'
import LargeHomeIcon from './large/home.svg?react'
import LargeHorseIcon from './large/horse.svg?react'
import LargeImageIcon from './large/image.svg?react'
import LargeInfoIcon from './large/info.svg?react'
import LargeInstagramIcon from './large/instagram.svg?react'
import LargeLayersIcon from './large/layers.svg?react'
import LargeLibraryIcon from './large/library.svg?react'
import LargeLinkIcon from './large/link.svg?react'
import LargeList2Icon from './large/list-2.svg?react'
import LargeList3Icon from './large/list-3.svg?react'
import LargeListPlusIcon from './large/list-plus.svg?react'
import LargeListIcon from './large/list.svg?react'
import LargeLocationIcon from './large/location.svg?react'
import LargeLogOutIcon from './large/log-out.svg?react'
import LargeMagnifierIcon from './large/magnifier.svg?react'
import LargeMarkerPinIcon from './large/marker-pin.svg?react'
import LargeMegaphoneIcon from './large/megaphone.svg?react'
import LargeMessageArrowUpIcon from './large/message-arrow-up.svg?react'
import LargeMessageCheckmarkIcon from './large/message-checkmark.svg?react'
import LargeMessageClockIcon from './large/message-clock.svg?react'
import LargeMessageIcon from './large/message.svg?react'
import LargeMessagesIcon from './large/messages.svg?react'
import LargeMoney2Icon from './large/money-2.svg?react'
import LargeMoneyAlarmClockIcon from './large/money-alarm-clock.svg?react'
import LargeMoneyIcon from './large/money.svg?react'
import LargeMonitorIcon from './large/monitor.svg?react'
import LargeMoonIcon from './large/moon.svg?react'
import LargeMoreHorizontalIcon from './large/more-horizontal.svg?react'
import LargeNoteIcon from './large/note.svg?react'
import LargeNotepadCheckmarkIcon from './large/notepad-checkmark.svg?react'
import LargeNotepadCheckmarksIcon from './large/notepad-checkmarks.svg?react'
import LargeNotepadIcon from './large/notepad.svg?react'
import LargePackage2Icon from './large/package-2.svg?react'
import LargePackageIcon from './large/package.svg?react'
import LargePaletteIcon from './large/palette.svg?react'
import LargePaperclipIcon from './large/paperclip.svg?react'
import LargePen2Icon from './large/pen-2.svg?react'
import LargePenIcon from './large/pen.svg?react'
import LargePencilIcon from './large/pencil.svg?react'
import LargePercentIcon from './large/percent.svg?react'
import LargePercentage2Icon from './large/percentage-2.svg?react'
import LargePercentage3Icon from './large/percentage-3.svg?react'
import LargePercentage4Icon from './large/percentage-4.svg?react'
import LargePercentageIcon from './large/percentage.svg?react'
import LargePhone2Icon from './large/phone-2.svg?react'
import LargePhoneArrowDownIcon from './large/phone-arrow-down.svg?react'
import LargePhoneArrowUpIcon from './large/phone-arrow-up.svg?react'
import LargePhoneIncomingIcon from './large/phone-incoming.svg?react'
import LargePhoneMissedIcon from './large/phone-missed.svg?react'
import LargePhoneOutgoingIcon from './large/phone-outgoing.svg?react'
import LargePhoneIcon from './large/phone.svg?react'
import LargePieIcon from './large/pie.svg?react'
import LargePinIcon from './large/pin.svg?react'
import LargePlusIcon from './large/plus.svg?react'
import LargePocketsuiteIcon from './large/pocketsuite.svg?react'
import LargeQuestionMarkIcon from './large/question-mark.svg?react'
import LargeReceiptIcon from './large/receipt.svg?react'
import LargeRefreshIcon from './large/refresh.svg?react'
import LargeRepeatIcon from './large/repeat.svg?react'
import LargeRocketIcon from './large/rocket.svg?react'
import LargeSafeIcon from './large/safe.svg?react'
import LargeSettingsIcon from './large/settings.svg?react'
import LargeShareIcon from './large/share.svg?react'
import LargeShieldLockIcon from './large/shield-lock.svg?react'
import LargeShoppingCartIcon from './large/shopping-cart.svg?react'
import LargeSlashIcon from './large/slash.svg?react'
import LargeSortIcon from './large/sort.svg?react'
import LargeStarIcon from './large/star.svg?react'
import LargeStopwatchIcon from './large/stopwatch.svg?react'
import LargeStudentIcon from './large/student.svg?react'
import LargeSunIcon from './large/sun.svg?react'
import LargeTableIcon from './large/table.svg?react'
import LargeTagIcon from './large/tag.svg?react'
import LargeTagsIcon from './large/tags.svg?react'
import LargeThumbsUpIcon from './large/thumbs-up.svg?react'
import LargeToolIcon from './large/tool.svg?react'
import LargeToolsIcon from './large/tools.svg?react'
import LargeTrashIcon from './large/trash.svg?react'
import LargeTrendingIcon from './large/trending.svg?react'
import LargeTrophyIcon from './large/trophy.svg?react'
import LargeTruckIcon from './large/truck.svg?react'
import LargeUploadIcon from './large/upload.svg?react'
import LargeUser2Icon from './large/user-2.svg?react'
import LargeUser3Icon from './large/user-3.svg?react'
import LargeUserPlusIcon from './large/user-plus.svg?react'
import LargeUserIcon from './large/user.svg?react'
import LargeUsersDocumentIcon from './large/users-document.svg?react'
import LargeUsersIcon from './large/users.svg?react'
import LargeVideoIcon from './large/video.svg?react'
import LargeVoiceIcon from './large/voice.svg?react'
import LargeWalletIcon from './large/wallet.svg?react'
import LargeWeightIcon from './large/weight.svg?react'
import LargeWindowClockIcon from './large/window-clock.svg?react'
import LargeWindowUserIcon from './large/window-user.svg?react'
import MediumAlarmClockIcon from './medium/alarm_clock.svg?react'
import MediumBankCardIcon from './medium/bank-card.svg?react'
import MediumBankIcon from './medium/bank.svg?react'
import MediumBedIcon from './medium/bed.svg?react'
import MediumBellOffIcon from './medium/bell-off.svg?react'
import MediumBellIcon from './medium/bell.svg?react'
import MediumBoneIcon from './medium/bone.svg?react'
import MediumBookIcon from './medium/book.svg?react'
import MediumBoxIcon from './medium/box.svg?react'
import MediumBriefcaseIcon from './medium/briefcase.svg?react'
import MediumBuildingsIcon from './medium/buildings.svg?react'
import MediumCalculatorIcon from './medium/calculator.svg?react'
import MediumCalendar2Icon from './medium/calendar-2.svg?react'
import MediumCalendarAlarmClockIcon from './medium/calendar-alarm-clock.svg?react'
import MediumCalendarArrowLeftIcon from './medium/calendar-arrow-left.svg?react'
import MediumCalendarArrowRightIcon from './medium/calendar-arrow-right.svg?react'
import MediumCalendarCheckIcon from './medium/calendar-check.svg?react'
import MediumCalendarClock2Icon from './medium/calendar-clock-2.svg?react'
import MediumCalendarClock3Icon from './medium/calendar-clock-3.svg?react'
import MediumCalendarClockIcon from './medium/calendar-clock.svg?react'
import MediumCalendarDollarIcon from './medium/calendar-dollar.svg?react'
import MediumCalendarMinusIcon from './medium/calendar-minus.svg?react'
import MediumCalendarPlusIcon from './medium/calendar-plus.svg?react'
import MediumCalendarRefreshIcon from './medium/calendar-refresh.svg?react'
import MediumCalendarIcon from './medium/calendar.svg?react'
import MediumCalendarsIcon from './medium/calendars.svg?react'
import MediumCameraIcon from './medium/camera.svg?react'
import MediumCapIcon from './medium/cap.svg?react'
import MediumCarIcon from './medium/car.svg?react'
import MediumCardReaderIcon from './medium/card-reader.svg?react'
import MediumCardsIcon from './medium/cards.svg?react'
import MediumCheckmarkIcon from './medium/checkmark.svg?react'
import MediumChevronDownIcon from './medium/chevron-down.svg?react'
import MediumChevronLeftIcon from './medium/chevron-left.svg?react'
import MediumChevronRightIcon from './medium/chevron-right.svg?react'
import MediumChevronUpIcon from './medium/chevron-up.svg?react'
import MediumChevronsDownIcon from './medium/chevrons-down.svg?react'
import MediumClipboardIcon from './medium/clipboard.svg?react'
import MediumClockLockIcon from './medium/clock-lock.svg?react'
import MediumClockIcon from './medium/clock.svg?react'
import MediumClose2Icon from './medium/close-2.svg?react'
import MediumCloseIcon from './medium/close.svg?react'
import MediumCogIcon from './medium/cog.svg?react'
import MediumCoins2Icon from './medium/coins-2.svg?react'
import MediumCoins3Icon from './medium/coins-3.svg?react'
import MediumCoinsHandIcon from './medium/coins-hand.svg?react'
import MediumCoinsIcon from './medium/coins.svg?react'
import MediumComputerCheckmarkIcon from './medium/computer-checkmark.svg?react'
import MediumComputerClockIcon from './medium/computer-clock.svg?react'
import MediumComputerDollarIcon from './medium/computer-dollar.svg?react'
import MediumComputerMessageIcon from './medium/computer-message.svg?react'
import MediumCopyIcon from './medium/copy.svg?react'
import MediumCornerUpRightIcon from './medium/corner-up-right.svg?react'
import MediumCrownIcon from './medium/crown.svg?react'
import MediumDiamondIcon from './medium/diamond.svg?react'
import MediumDiscountIcon from './medium/discount.svg?react'
import MediumDocument2Icon from './medium/document-2.svg?react'
import MediumDocumentClockIcon from './medium/document-clock.svg?react'
import MediumDocumentLockIcon from './medium/document-lock.svg?react'
import MediumDocumentPenIcon from './medium/document-pen.svg?react'
import MediumDollar2Icon from './medium/dollar-2.svg?react'
import MediumDollar3Icon from './medium/dollar-3.svg?react'
import MediumDollar4Icon from './medium/dollar-4.svg?react'
import MediumDollar5Icon from './medium/dollar-5.svg?react'
import MediumDollar6Icon from './medium/dollar-6.svg?react'
import MediumDollar7Icon from './medium/dollar-7.svg?react'
import MediumDollar9Icon from './medium/dollar-9.svg?react'
import MediumDollarIcon from './medium/dollar.svg?react'
import MediumDragIcon from './medium/drag.svg?react'
import MediumDropboxIcon from './medium/dropbox.svg?react'
import MediumEmployeeCardIcon from './medium/employee-card.svg?react'
import MediumEnvelopeClockIcon from './medium/envelope-clock.svg?react'
import MediumEnvelopeIcon from './medium/envelope.svg?react'
import MediumExclamationIcon from './medium/exclamation.svg?react'
import MediumExternalLinkIcon from './medium/external-link.svg?react'
import MediumEyeOffIcon from './medium/eye-off.svg?react'
import MediumEyeIcon from './medium/eye.svg?react'
import MediumFaceFrownIcon from './medium/face-frown.svg?react'
import MediumFaceSmileIcon from './medium/face-smile.svg?react'
import MediumField2Icon from './medium/field-2.svg?react'
import MediumFieldIcon from './medium/field.svg?react'
import MediumFileIcon from './medium/file.svg?react'
import MediumFilterIcon from './medium/filter.svg?react'
import MediumFlagIcon from './medium/flag.svg?react'
import MediumFloppyDiskIcon from './medium/floppy-disk.svg?react'
import MediumFolderPenIcon from './medium/folder-pen.svg?react'
import MediumFolderIcon from './medium/folder.svg?react'
import MediumForm2Icon from './medium/form-2.svg?react'
import MediumFormIcon from './medium/form.svg?react'
import MediumGiftIcon from './medium/gift.svg?react'
import MediumGlobe2Icon from './medium/globe-2.svg?react'
import MediumGlobeClockIcon from './medium/globe-clock.svg?react'
import MediumGlobeIcon from './medium/globe.svg?react'
import MediumGoogleDriveIcon from './medium/google-drive.svg?react'
import MediumGoogleIcon from './medium/google.svg?react'
import MediumGraph2Icon from './medium/graph-2.svg?react'
import MediumGraphIcon from './medium/graph.svg?react'
import MediumGrid2Icon from './medium/grid-2.svg?react'
import MediumGridIcon from './medium/grid.svg?react'
import MediumHandIcon from './medium/hand.svg?react'
import MediumHashIcon from './medium/hash.svg?react'
import MediumHomeIcon from './medium/home.svg?react'
import MediumHorseIcon from './medium/horse.svg?react'
import MediumImageIcon from './medium/image.svg?react'
import MediumInfoIcon from './medium/info.svg?react'
import MediumInstagram1Icon from './medium/instagram-1.svg?react'
import MediumInstagramIcon from './medium/instagram.svg?react'
import MediumLayersIcon from './medium/layers.svg?react'
import MediumLibraryIcon from './medium/library.svg?react'
import MediumLinkIcon from './medium/link.svg?react'
import MediumList2Icon from './medium/list-2.svg?react'
import MediumList3Icon from './medium/list-3.svg?react'
import MediumListPlusIcon from './medium/list-plus.svg?react'
import MediumListIcon from './medium/list.svg?react'
import MediumLocationIcon from './medium/location.svg?react'
import MediumLogOutIcon from './medium/log-out.svg?react'
import MediumMagnifierIcon from './medium/magnifier.svg?react'
import MediumMarkerPinIcon from './medium/marker-pin.svg?react'
import MediumMegaphoneIcon from './medium/megaphone.svg?react'
import MediumMessageArrowUpIcon from './medium/message-arrow-up.svg?react'
import MediumMessageCheckmarkIcon from './medium/message-checkmark.svg?react'
import MediumMessageClockIcon from './medium/message-clock.svg?react'
import MediumMessageIcon from './medium/message.svg?react'
import MediumMessagesIcon from './medium/messages.svg?react'
import MediumMoney2Icon from './medium/money-2.svg?react'
import MediumMoneyAlarmClockIcon from './medium/money-alarm-clock.svg?react'
import MediumMoneyIcon from './medium/money.svg?react'
import MediumMonitorIcon from './medium/monitor.svg?react'
import MediumMoonIcon from './medium/moon.svg?react'
import MediumMoreHorizontalIcon from './medium/more-horizontal.svg?react'
import MediumNoteIcon from './medium/note.svg?react'
import MediumNotepadCheckmarkIcon from './medium/notepad-checkmark.svg?react'
import MediumNotepadCheckmarksIcon from './medium/notepad-checkmarks.svg?react'
import MediumNotepadIcon from './medium/notepad.svg?react'
import MediumPackage2Icon from './medium/package-2.svg?react'
import MediumPackageIcon from './medium/package.svg?react'
import MediumPaletteIcon from './medium/palette.svg?react'
import MediumPaperclipIcon from './medium/paperclip.svg?react'
import MediumPen2Icon from './medium/pen-2.svg?react'
import MediumPenIcon from './medium/pen.svg?react'
import MediumPencilIcon from './medium/pencil.svg?react'
import MediumPercentIcon from './medium/percent.svg?react'
import MediumPercentage2Icon from './medium/percentage-2.svg?react'
import MediumPercentage3Icon from './medium/percentage-3.svg?react'
import MediumPercentage4Icon from './medium/percentage-4.svg?react'
import MediumPercentageIcon from './medium/percentage.svg?react'
import MediumPhone2Icon from './medium/phone-2.svg?react'
import MediumPhoneArrowDownIcon from './medium/phone-arrow-down.svg?react'
import MediumPhoneArrowUpIcon from './medium/phone-arrow-up.svg?react'
import MediumPhoneIncomingIcon from './medium/phone-incoming.svg?react'
import MediumPhoneMissedIcon from './medium/phone-missed.svg?react'
import MediumPhoneOutgoingIcon from './medium/phone-outgoing.svg?react'
import MediumPhoneIcon from './medium/phone.svg?react'
import MediumPieIcon from './medium/pie.svg?react'
import MediumPinIcon from './medium/pin.svg?react'
import MediumPlusIcon from './medium/plus.svg?react'
import MediumPocketsuiteIcon from './medium/pocketsuite.svg?react'
import MediumQuestionMarkIcon from './medium/question-mark.svg?react'
import MediumReceiptIcon from './medium/receipt.svg?react'
import MediumRefreshIcon from './medium/refresh.svg?react'
import MediumRepeatIcon from './medium/repeat.svg?react'
import MediumRocketIcon from './medium/rocket.svg?react'
import MediumSafeIcon from './medium/safe.svg?react'
import MediumSettingsIcon from './medium/settings.svg?react'
import MediumShareIcon from './medium/share.svg?react'
import MediumShieldLockIcon from './medium/shield-lock.svg?react'
import MediumShoppingCartIcon from './medium/shopping-cart.svg?react'
import MediumSlashIcon from './medium/slash.svg?react'
import MediumSortIcon from './medium/sort.svg?react'
import MediumStarIcon from './medium/star.svg?react'
import MediumStopwatchIcon from './medium/stopwatch.svg?react'
import MediumStudentIcon from './medium/student.svg?react'
import MediumSunIcon from './medium/sun.svg?react'
import MediumTableIcon from './medium/table.svg?react'
import MediumTagIcon from './medium/tag.svg?react'
import MediumTagsIcon from './medium/tags.svg?react'
import MediumThumbsUpIcon from './medium/thumbs-up.svg?react'
import MediumToolIcon from './medium/tool.svg?react'
import MediumToolsIcon from './medium/tools.svg?react'
import MediumTrashIcon from './medium/trash.svg?react'
import MediumTrendingIcon from './medium/trending.svg?react'
import MediumTrophyIcon from './medium/trophy.svg?react'
import MediumTruckIcon from './medium/truck.svg?react'
import MediumUploadIcon from './medium/upload.svg?react'
import MediumUser2Icon from './medium/user-2.svg?react'
import MediumUser3Icon from './medium/user-3.svg?react'
import MediumUserPlusIcon from './medium/user-plus.svg?react'
import MediumUserIcon from './medium/user.svg?react'
import MediumUsersDocumentIcon from './medium/users-document.svg?react'
import MediumUsersIcon from './medium/users.svg?react'
import MediumVideoIcon from './medium/video.svg?react'
import MediumVoiceIcon from './medium/voice.svg?react'
import MediumWalletIcon from './medium/wallet.svg?react'
import MediumWeightIcon from './medium/weight.svg?react'
import MediumWindowClockIcon from './medium/window-clock.svg?react'
import MediumWindowUserIcon from './medium/window-user.svg?react'
import PaymentAmexIcon from './payment/Amex.svg?react'
import PaymentApplePayIcon from './payment/Apple_Pay.svg?react'
import PaymentDiscoverIcon from './payment/Discover.svg?react'
import PaymentMastercardIcon from './payment/Mastercard.svg?react'
import PaymentVisaIcon from './payment/Visa.svg?react'
import SmallAlarmClockIcon from './small/alarm_clock.svg?react'
import SmallBankCardIcon from './small/bank-card.svg?react'
import SmallBankIcon from './small/bank.svg?react'
import SmallBedIcon from './small/bed.svg?react'
import SmallBellOffIcon from './small/bell-off.svg?react'
import SmallBellIcon from './small/bell.svg?react'
import SmallBoneIcon from './small/bone.svg?react'
import SmallBookIcon from './small/book.svg?react'
import SmallBoxIcon from './small/box.svg?react'
import SmallBriefcaseIcon from './small/briefcase.svg?react'
import SmallBuildingsIcon from './small/buildings.svg?react'
import SmallCalculatorIcon from './small/calculator.svg?react'
import SmallCalendar2Icon from './small/calendar-2.svg?react'
import SmallCalendarAlarmClockIcon from './small/calendar-alarm-clock.svg?react'
import SmallCalendarArrowLeftIcon from './small/calendar-arrow-left.svg?react'
import SmallCalendarArrowRightIcon from './small/calendar-arrow-right.svg?react'
import SmallCalendarCheckIcon from './small/calendar-check.svg?react'
import SmallCalendarClock2Icon from './small/calendar-clock-2.svg?react'
import SmallCalendarClock3Icon from './small/calendar-clock-3.svg?react'
import SmallCalendarClockIcon from './small/calendar-clock.svg?react'
import SmallCalendarDollarIcon from './small/calendar-dollar.svg?react'
import SmallCalendarMinusIcon from './small/calendar-minus.svg?react'
import SmallCalendarPlusIcon from './small/calendar-plus.svg?react'
import SmallCalendarRefreshIcon from './small/calendar-refresh.svg?react'
import SmallCalendarIcon from './small/calendar.svg?react'
import SmallCalendarsIcon from './small/calendars.svg?react'
import SmallCameraIcon from './small/camera.svg?react'
import SmallCapIcon from './small/cap.svg?react'
import SmallCarIcon from './small/car.svg?react'
import SmallCardReaderIcon from './small/card-reader.svg?react'
import SmallCardsIcon from './small/cards.svg?react'
import SmallCheckmarkIcon from './small/checkmark.svg?react'
import SmallChevronDownIcon from './small/chevron-down.svg?react'
import SmallChevronLeftIcon from './small/chevron-left.svg?react'
import SmallChevronRightIcon from './small/chevron-right.svg?react'
import SmallChevronUpIcon from './small/chevron-up.svg?react'
import SmallChevronsDownIcon from './small/chevrons-down.svg?react'
import SmallClipboardIcon from './small/clipboard.svg?react'
import SmallClockLockIcon from './small/clock-lock.svg?react'
import SmallClockIcon from './small/clock.svg?react'
import SmallClose2Icon from './small/close-2.svg?react'
import SmallCloseIcon from './small/close.svg?react'
import SmallCogIcon from './small/cog.svg?react'
import SmallCoins2Icon from './small/coins-2.svg?react'
import SmallCoins3Icon from './small/coins-3.svg?react'
import SmallCoinsHandIcon from './small/coins-hand.svg?react'
import SmallCoinsIcon from './small/coins.svg?react'
import SmallComputerCheckmarkIcon from './small/computer-checkmark.svg?react'
import SmallComputerClockIcon from './small/computer-clock.svg?react'
import SmallComputerDollarIcon from './small/computer-dollar.svg?react'
import SmallComputerMessageIcon from './small/computer-message.svg?react'
import SmallCopyIcon from './small/copy.svg?react'
import SmallCornerUpRightIcon from './small/corner-up-right.svg?react'
import SmallCrownIcon from './small/crown.svg?react'
import SmallDiamondIcon from './small/diamond.svg?react'
import SmallDiscountIcon from './small/discount.svg?react'
import SmallDocument2Icon from './small/document-2.svg?react'
import SmallDocumentClockIcon from './small/document-clock.svg?react'
import SmallDocumentLockIcon from './small/document-lock.svg?react'
import SmallDocumentPenIcon from './small/document-pen.svg?react'
import SmallDollar2Icon from './small/dollar-2.svg?react'
import SmallDollar3Icon from './small/dollar-3.svg?react'
import SmallDollar4Icon from './small/dollar-4.svg?react'
import SmallDollar5Icon from './small/dollar-5.svg?react'
import SmallDollar6Icon from './small/dollar-6.svg?react'
import SmallDollar7Icon from './small/dollar-7.svg?react'
import SmallDollar9Icon from './small/dollar-9.svg?react'
import SmallDollarIcon from './small/dollar.svg?react'
import SmallDragIcon from './small/drag.svg?react'
import SmallDropboxIcon from './small/dropbox.svg?react'
import SmallEmployeeCardIcon from './small/employee-card.svg?react'
import SmallEnvelopeClockIcon from './small/envelope-clock.svg?react'
import SmallEnvelopeIcon from './small/envelope.svg?react'
import SmallExclamationIcon from './small/exclamation.svg?react'
import SmallExternalLinkIcon from './small/external-link.svg?react'
import SmallEyeOffIcon from './small/eye-off.svg?react'
import SmallEyeIcon from './small/eye.svg?react'
import SmallFaceFrownIcon from './small/face-frown.svg?react'
import SmallFaceSmileIcon from './small/face-smile.svg?react'
import SmallField2Icon from './small/field-2.svg?react'
import SmallFieldIcon from './small/field.svg?react'
import SmallFileIcon from './small/file.svg?react'
import SmallFilterIcon from './small/filter.svg?react'
import SmallFlagIcon from './small/flag.svg?react'
import SmallFloppyDiskIcon from './small/floppy-disk.svg?react'
import SmallFolderPenIcon from './small/folder-pen.svg?react'
import SmallFolderIcon from './small/folder.svg?react'
import SmallForm2Icon from './small/form-2.svg?react'
import SmallFormIcon from './small/form.svg?react'
import SmallGiftIcon from './small/gift.svg?react'
import SmallGlobe2Icon from './small/globe-2.svg?react'
import SmallGlobeClockIcon from './small/globe-clock.svg?react'
import SmallGlobeIcon from './small/globe.svg?react'
import SmallGoogleDriveIcon from './small/google-drive.svg?react'
import SmallGoogleIcon from './small/google.svg?react'
import SmallGraph2Icon from './small/graph-2.svg?react'
import SmallGraphIcon from './small/graph.svg?react'
import SmallGrid2Icon from './small/grid-2.svg?react'
import SmallGridIcon from './small/grid.svg?react'
import SmallHandIcon from './small/hand.svg?react'
import SmallHashIcon from './small/hash.svg?react'
import SmallHomeIcon from './small/home.svg?react'
import SmallHorseIcon from './small/horse.svg?react'
import SmallImageIcon from './small/image.svg?react'
import SmallInfoIcon from './small/info.svg?react'
import SmallInstagram1Icon from './small/instagram-1.svg?react'
import SmallInstagramIcon from './small/instagram.svg?react'
import SmallLayersIcon from './small/layers.svg?react'
import SmallLibraryIcon from './small/library.svg?react'
import SmallLinkIcon from './small/link.svg?react'
import SmallList2Icon from './small/list-2.svg?react'
import SmallList3Icon from './small/list-3.svg?react'
import SmallListPlusIcon from './small/list-plus.svg?react'
import SmallListIcon from './small/list.svg?react'
import SmallLocationIcon from './small/location.svg?react'
import SmallLogOutIcon from './small/log-out.svg?react'
import SmallMagnifierIcon from './small/magnifier.svg?react'
import SmallMarkerPinIcon from './small/marker-pin.svg?react'
import SmallMegaphoneIcon from './small/megaphone.svg?react'
import SmallMessageArrowUpIcon from './small/message-arrow-up.svg?react'
import SmallMessageCheckmarkIcon from './small/message-checkmark.svg?react'
import SmallMessageClockIcon from './small/message-clock.svg?react'
import SmallMessageIcon from './small/message.svg?react'
import SmallMessagesIcon from './small/messages.svg?react'
import SmallMoney2Icon from './small/money-2.svg?react'
import SmallMoneyAlarmClockIcon from './small/money-alarm-clock.svg?react'
import SmallMoneyIcon from './small/money.svg?react'
import SmallMonitorIcon from './small/monitor.svg?react'
import SmallMoonIcon from './small/moon.svg?react'
import SmallMoreHorizontalIcon from './small/more-horizontal.svg?react'
import SmallNoteIcon from './small/note.svg?react'
import SmallNotepadCheckmarkIcon from './small/notepad-checkmark.svg?react'
import SmallNotepadCheckmarksIcon from './small/notepad-checkmarks.svg?react'
import SmallNotepadIcon from './small/notepad.svg?react'
import SmallPackage2Icon from './small/package-2.svg?react'
import SmallPackageIcon from './small/package.svg?react'
import SmallPaletteIcon from './small/palette.svg?react'
import SmallPaperclipIcon from './small/paperclip.svg?react'
import SmallPen2Icon from './small/pen-2.svg?react'
import SmallPenIcon from './small/pen.svg?react'
import SmallPencilIcon from './small/pencil.svg?react'
import SmallPercentIcon from './small/percent.svg?react'
import SmallPercentage2Icon from './small/percentage-2.svg?react'
import SmallPercentage3Icon from './small/percentage-3.svg?react'
import SmallPercentage4Icon from './small/percentage-4.svg?react'
import SmallPercentageIcon from './small/percentage.svg?react'
import SmallPhone2Icon from './small/phone-2.svg?react'
import SmallPhoneArrowDownIcon from './small/phone-arrow-down.svg?react'
import SmallPhoneArrowUpIcon from './small/phone-arrow-up.svg?react'
import SmallPhoneIncomingIcon from './small/phone-incoming.svg?react'
import SmallPhoneMissedIcon from './small/phone-missed.svg?react'
import SmallPhoneOutgoingIcon from './small/phone-outgoing.svg?react'
import SmallPhoneIcon from './small/phone.svg?react'
import SmallPieIcon from './small/pie.svg?react'
import SmallPinIcon from './small/pin.svg?react'
import SmallPlusIcon from './small/plus.svg?react'
import SmallPocketsuiteIcon from './small/pocketsuite.svg?react'
import SmallQuestionMarkIcon from './small/question-mark.svg?react'
import SmallReceiptIcon from './small/receipt.svg?react'
import SmallRefreshIcon from './small/refresh.svg?react'
import SmallRepeatIcon from './small/repeat.svg?react'
import SmallRocketIcon from './small/rocket.svg?react'
import SmallSafeIcon from './small/safe.svg?react'
import SmallSettingsIcon from './small/settings.svg?react'
import SmallShareIcon from './small/share.svg?react'
import SmallShieldLockIcon from './small/shield-lock.svg?react'
import SmallShoppingCartIcon from './small/shopping-cart.svg?react'
import SmallSlashIcon from './small/slash.svg?react'
import SmallSortIcon from './small/sort.svg?react'
import SmallStarIcon from './small/star.svg?react'
import SmallStopwatchIcon from './small/stopwatch.svg?react'
import SmallStudentIcon from './small/student.svg?react'
import SmallSunIcon from './small/sun.svg?react'
import SmallTableIcon from './small/table.svg?react'
import SmallTagIcon from './small/tag.svg?react'
import SmallTagsIcon from './small/tags.svg?react'
import SmallThumbsUpIcon from './small/thumbs-up.svg?react'
import SmallToolIcon from './small/tool.svg?react'
import SmallToolsIcon from './small/tools.svg?react'
import SmallTrashIcon from './small/trash.svg?react'
import SmallTrendingIcon from './small/trending.svg?react'
import SmallTrophyIcon from './small/trophy.svg?react'
import SmallTruckIcon from './small/truck.svg?react'
import SmallUploadIcon from './small/upload.svg?react'
import SmallUser2Icon from './small/user-2.svg?react'
import SmallUser3Icon from './small/user-3.svg?react'
import SmallUserPlusIcon from './small/user-plus.svg?react'
import SmallUserIcon from './small/user.svg?react'
import SmallUsersDocumentIcon from './small/users-document.svg?react'
import SmallUsersIcon from './small/users.svg?react'
import SmallVideoIcon from './small/video.svg?react'
import SmallVoiceIcon from './small/voice.svg?react'
import SmallWalletIcon from './small/wallet.svg?react'
import SmallWeightIcon from './small/weight.svg?react'
import SmallWindowClockIcon from './small/window-clock.svg?react'
import SmallWindowUserIcon from './small/window-user.svg?react'

export const icons = {
    large: {
        alarmClock: LargeAlarmClockIcon,
        bankCard: LargeBankCardIcon,
        bank: LargeBankIcon,
        bed: LargeBedIcon,
        bellOff: LargeBellOffIcon,
        bell: LargeBellIcon,
        bone: LargeBoneIcon,
        book: LargeBookIcon,
        box: LargeBoxIcon,
        briefcase: LargeBriefcaseIcon,
        buildings: LargeBuildingsIcon,
        calculator: LargeCalculatorIcon,
        calendar2: LargeCalendar2Icon,
        calendarAlarmClock: LargeCalendarAlarmClockIcon,
        calendarArrowLeft: LargeCalendarArrowLeftIcon,
        calendarArrowRight: LargeCalendarArrowRightIcon,
        calendarCheck: LargeCalendarCheckIcon,
        calendarClock2: LargeCalendarClock2Icon,
        calendarClock3: LargeCalendarClock3Icon,
        calendarClock: LargeCalendarClockIcon,
        calendarDollar: LargeCalendarDollarIcon,
        calendarMinus: LargeCalendarMinusIcon,
        calendarPlus: LargeCalendarPlusIcon,
        calendarRefresh: LargeCalendarRefreshIcon,
        calendar: LargeCalendarIcon,
        calendars: LargeCalendarsIcon,
        camera: LargeCameraIcon,
        cap: LargeCapIcon,
        car: LargeCarIcon,
        cardReader: LargeCardReaderIcon,
        cards: LargeCardsIcon,
        checkmark: LargeCheckmarkIcon,
        chevronDown: LargeChevronDownIcon,
        chevronLeft: LargeChevronLeftIcon,
        chevronRight: LargeChevronRightIcon,
        chevronUp: LargeChevronUpIcon,
        chevronsDown: LargeChevronsDownIcon,
        clipboard: LargeClipboardIcon,
        clockLock: LargeClockLockIcon,
        clock: LargeClockIcon,
        close2: LargeClose2Icon,
        close: LargeCloseIcon,
        cog: LargeCogIcon,
        coins2: LargeCoins2Icon,
        coins3: LargeCoins3Icon,
        coinsHand: LargeCoinsHandIcon,
        coins: LargeCoinsIcon,
        computerCheckmark: LargeComputerCheckmarkIcon,
        computerClock: LargeComputerClockIcon,
        computerDollar: LargeComputerDollarIcon,
        computerMessage: LargeComputerMessageIcon,
        copy: LargeCopyIcon,
        cornerUpRight: LargeCornerUpRightIcon,
        crown: LargeCrownIcon,
        diamond: LargeDiamondIcon,
        discount: LargeDiscountIcon,
        document2: LargeDocument2Icon,
        documentClock: LargeDocumentClockIcon,
        documentLock: LargeDocumentLockIcon,
        documentPen: LargeDocumentPenIcon,
        dollar2: LargeDollar2Icon,
        dollar3: LargeDollar3Icon,
        dollar4: LargeDollar4Icon,
        dollar5: LargeDollar5Icon,
        dollar6: LargeDollar6Icon,
        dollar7: LargeDollar7Icon,
        dollar9: LargeDollar9Icon,
        dollar: LargeDollarIcon,
        drag: LargeDragIcon,
        dropbox: LargeDropboxIcon,
        employeeCard: LargeEmployeeCardIcon,
        envelopeClock: LargeEnvelopeClockIcon,
        envelope: LargeEnvelopeIcon,
        exclamation: LargeExclamationIcon,
        externalLink: LargeExternalLinkIcon,
        eyeOff: LargeEyeOffIcon,
        eye: LargeEyeIcon,
        faceFrown: LargeFaceFrownIcon,
        faceSmile: LargeFaceSmileIcon,
        field2: LargeField2Icon,
        field: LargeFieldIcon,
        file: LargeFileIcon,
        filter: LargeFilterIcon,
        flag: LargeFlagIcon,
        floppyDisk: LargeFloppyDiskIcon,
        folderPen: LargeFolderPenIcon,
        folder: LargeFolderIcon,
        form2: LargeForm2Icon,
        form: LargeFormIcon,
        gift: LargeGiftIcon,
        globe2: LargeGlobe2Icon,
        globeClock: LargeGlobeClockIcon,
        globe: LargeGlobeIcon,
        googleDrive: LargeGoogleDriveIcon,
        google: LargeGoogleIcon,
        graph2: LargeGraph2Icon,
        graph: LargeGraphIcon,
        grid2: LargeGrid2Icon,
        grid: LargeGridIcon,
        hand: LargeHandIcon,
        hash: LargeHashIcon,
        home: LargeHomeIcon,
        horse: LargeHorseIcon,
        image: LargeImageIcon,
        info: LargeInfoIcon,
        instagram: LargeInstagramIcon,
        layers: LargeLayersIcon,
        library: LargeLibraryIcon,
        link: LargeLinkIcon,
        list2: LargeList2Icon,
        list3: LargeList3Icon,
        listPlus: LargeListPlusIcon,
        list: LargeListIcon,
        location: LargeLocationIcon,
        logOut: LargeLogOutIcon,
        magnifier: LargeMagnifierIcon,
        markerPin: LargeMarkerPinIcon,
        megaphone: LargeMegaphoneIcon,
        messageArrowUp: LargeMessageArrowUpIcon,
        messageCheckmark: LargeMessageCheckmarkIcon,
        messageClock: LargeMessageClockIcon,
        message: LargeMessageIcon,
        messages: LargeMessagesIcon,
        money2: LargeMoney2Icon,
        moneyAlarmClock: LargeMoneyAlarmClockIcon,
        money: LargeMoneyIcon,
        monitor: LargeMonitorIcon,
        moon: LargeMoonIcon,
        moreHorizontal: LargeMoreHorizontalIcon,
        note: LargeNoteIcon,
        notepadCheckmark: LargeNotepadCheckmarkIcon,
        notepadCheckmarks: LargeNotepadCheckmarksIcon,
        notepad: LargeNotepadIcon,
        package2: LargePackage2Icon,
        package: LargePackageIcon,
        palette: LargePaletteIcon,
        paperclip: LargePaperclipIcon,
        pen2: LargePen2Icon,
        pen: LargePenIcon,
        pencil: LargePencilIcon,
        percent: LargePercentIcon,
        percentage2: LargePercentage2Icon,
        percentage3: LargePercentage3Icon,
        percentage4: LargePercentage4Icon,
        percentage: LargePercentageIcon,
        phone2: LargePhone2Icon,
        phoneArrowDown: LargePhoneArrowDownIcon,
        phoneArrowUp: LargePhoneArrowUpIcon,
        phoneIncoming: LargePhoneIncomingIcon,
        phoneMissed: LargePhoneMissedIcon,
        phoneOutgoing: LargePhoneOutgoingIcon,
        phone: LargePhoneIcon,
        pie: LargePieIcon,
        pin: LargePinIcon,
        plus: LargePlusIcon,
        pocketsuite: LargePocketsuiteIcon,
        questionMark: LargeQuestionMarkIcon,
        receipt: LargeReceiptIcon,
        refresh: LargeRefreshIcon,
        repeat: LargeRepeatIcon,
        rocket: LargeRocketIcon,
        safe: LargeSafeIcon,
        settings: LargeSettingsIcon,
        share: LargeShareIcon,
        shieldLock: LargeShieldLockIcon,
        shoppingCart: LargeShoppingCartIcon,
        slash: LargeSlashIcon,
        sort: LargeSortIcon,
        star: LargeStarIcon,
        stopwatch: LargeStopwatchIcon,
        student: LargeStudentIcon,
        sun: LargeSunIcon,
        table: LargeTableIcon,
        tag: LargeTagIcon,
        tags: LargeTagsIcon,
        thumbsUp: LargeThumbsUpIcon,
        tool: LargeToolIcon,
        tools: LargeToolsIcon,
        trash: LargeTrashIcon,
        trending: LargeTrendingIcon,
        trophy: LargeTrophyIcon,
        truck: LargeTruckIcon,
        upload: LargeUploadIcon,
        user2: LargeUser2Icon,
        user3: LargeUser3Icon,
        userPlus: LargeUserPlusIcon,
        user: LargeUserIcon,
        usersDocument: LargeUsersDocumentIcon,
        users: LargeUsersIcon,
        video: LargeVideoIcon,
        voice: LargeVoiceIcon,
        wallet: LargeWalletIcon,
        weight: LargeWeightIcon,
        windowClock: LargeWindowClockIcon,
        windowUser: LargeWindowUserIcon,
    },
    medium: {
        alarmClock: MediumAlarmClockIcon,
        bankCard: MediumBankCardIcon,
        bank: MediumBankIcon,
        bed: MediumBedIcon,
        bellOff: MediumBellOffIcon,
        bell: MediumBellIcon,
        bone: MediumBoneIcon,
        book: MediumBookIcon,
        box: MediumBoxIcon,
        briefcase: MediumBriefcaseIcon,
        buildings: MediumBuildingsIcon,
        calculator: MediumCalculatorIcon,
        calendar2: MediumCalendar2Icon,
        calendarAlarmClock: MediumCalendarAlarmClockIcon,
        calendarArrowLeft: MediumCalendarArrowLeftIcon,
        calendarArrowRight: MediumCalendarArrowRightIcon,
        calendarCheck: MediumCalendarCheckIcon,
        calendarClock2: MediumCalendarClock2Icon,
        calendarClock3: MediumCalendarClock3Icon,
        calendarClock: MediumCalendarClockIcon,
        calendarDollar: MediumCalendarDollarIcon,
        calendarMinus: MediumCalendarMinusIcon,
        calendarPlus: MediumCalendarPlusIcon,
        calendarRefresh: MediumCalendarRefreshIcon,
        calendar: MediumCalendarIcon,
        calendars: MediumCalendarsIcon,
        camera: MediumCameraIcon,
        cap: MediumCapIcon,
        car: MediumCarIcon,
        cardReader: MediumCardReaderIcon,
        cards: MediumCardsIcon,
        checkmark: MediumCheckmarkIcon,
        chevronDown: MediumChevronDownIcon,
        chevronLeft: MediumChevronLeftIcon,
        chevronRight: MediumChevronRightIcon,
        chevronUp: MediumChevronUpIcon,
        chevronsDown: MediumChevronsDownIcon,
        clipboard: MediumClipboardIcon,
        clockLock: MediumClockLockIcon,
        clock: MediumClockIcon,
        close2: MediumClose2Icon,
        close: MediumCloseIcon,
        cog: MediumCogIcon,
        coins2: MediumCoins2Icon,
        coins3: MediumCoins3Icon,
        coinsHand: MediumCoinsHandIcon,
        coins: MediumCoinsIcon,
        computerCheckmark: MediumComputerCheckmarkIcon,
        computerClock: MediumComputerClockIcon,
        computerDollar: MediumComputerDollarIcon,
        computerMessage: MediumComputerMessageIcon,
        copy: MediumCopyIcon,
        cornerUpRight: MediumCornerUpRightIcon,
        crown: MediumCrownIcon,
        diamond: MediumDiamondIcon,
        discount: MediumDiscountIcon,
        document2: MediumDocument2Icon,
        documentClock: MediumDocumentClockIcon,
        documentLock: MediumDocumentLockIcon,
        documentPen: MediumDocumentPenIcon,
        dollar2: MediumDollar2Icon,
        dollar3: MediumDollar3Icon,
        dollar4: MediumDollar4Icon,
        dollar5: MediumDollar5Icon,
        dollar6: MediumDollar6Icon,
        dollar7: MediumDollar7Icon,
        dollar9: MediumDollar9Icon,
        dollar: MediumDollarIcon,
        drag: MediumDragIcon,
        dropbox: MediumDropboxIcon,
        employeeCard: MediumEmployeeCardIcon,
        envelopeClock: MediumEnvelopeClockIcon,
        envelope: MediumEnvelopeIcon,
        exclamation: MediumExclamationIcon,
        externalLink: MediumExternalLinkIcon,
        eyeOff: MediumEyeOffIcon,
        eye: MediumEyeIcon,
        faceFrown: MediumFaceFrownIcon,
        faceSmile: MediumFaceSmileIcon,
        field2: MediumField2Icon,
        field: MediumFieldIcon,
        file: MediumFileIcon,
        filter: MediumFilterIcon,
        flag: MediumFlagIcon,
        floppyDisk: MediumFloppyDiskIcon,
        folderPen: MediumFolderPenIcon,
        folder: MediumFolderIcon,
        form2: MediumForm2Icon,
        form: MediumFormIcon,
        gift: MediumGiftIcon,
        globe2: MediumGlobe2Icon,
        globeClock: MediumGlobeClockIcon,
        globe: MediumGlobeIcon,
        googleDrive: MediumGoogleDriveIcon,
        google: MediumGoogleIcon,
        graph2: MediumGraph2Icon,
        graph: MediumGraphIcon,
        grid2: MediumGrid2Icon,
        grid: MediumGridIcon,
        hand: MediumHandIcon,
        hash: MediumHashIcon,
        home: MediumHomeIcon,
        horse: MediumHorseIcon,
        image: MediumImageIcon,
        info: MediumInfoIcon,
        instagram1: MediumInstagram1Icon,
        instagram: MediumInstagramIcon,
        layers: MediumLayersIcon,
        library: MediumLibraryIcon,
        link: MediumLinkIcon,
        list2: MediumList2Icon,
        list3: MediumList3Icon,
        listPlus: MediumListPlusIcon,
        list: MediumListIcon,
        location: MediumLocationIcon,
        logOut: MediumLogOutIcon,
        magnifier: MediumMagnifierIcon,
        markerPin: MediumMarkerPinIcon,
        megaphone: MediumMegaphoneIcon,
        messageArrowUp: MediumMessageArrowUpIcon,
        messageCheckmark: MediumMessageCheckmarkIcon,
        messageClock: MediumMessageClockIcon,
        message: MediumMessageIcon,
        messages: MediumMessagesIcon,
        money2: MediumMoney2Icon,
        moneyAlarmClock: MediumMoneyAlarmClockIcon,
        money: MediumMoneyIcon,
        monitor: MediumMonitorIcon,
        moon: MediumMoonIcon,
        moreHorizontal: MediumMoreHorizontalIcon,
        note: MediumNoteIcon,
        notepadCheckmark: MediumNotepadCheckmarkIcon,
        notepadCheckmarks: MediumNotepadCheckmarksIcon,
        notepad: MediumNotepadIcon,
        package2: MediumPackage2Icon,
        package: MediumPackageIcon,
        palette: MediumPaletteIcon,
        paperclip: MediumPaperclipIcon,
        pen2: MediumPen2Icon,
        pen: MediumPenIcon,
        pencil: MediumPencilIcon,
        percent: MediumPercentIcon,
        percentage2: MediumPercentage2Icon,
        percentage3: MediumPercentage3Icon,
        percentage4: MediumPercentage4Icon,
        percentage: MediumPercentageIcon,
        phone2: MediumPhone2Icon,
        phoneArrowDown: MediumPhoneArrowDownIcon,
        phoneArrowUp: MediumPhoneArrowUpIcon,
        phoneIncoming: MediumPhoneIncomingIcon,
        phoneMissed: MediumPhoneMissedIcon,
        phoneOutgoing: MediumPhoneOutgoingIcon,
        phone: MediumPhoneIcon,
        pie: MediumPieIcon,
        pin: MediumPinIcon,
        plus: MediumPlusIcon,
        pocketsuite: MediumPocketsuiteIcon,
        questionMark: MediumQuestionMarkIcon,
        receipt: MediumReceiptIcon,
        refresh: MediumRefreshIcon,
        repeat: MediumRepeatIcon,
        rocket: MediumRocketIcon,
        safe: MediumSafeIcon,
        settings: MediumSettingsIcon,
        share: MediumShareIcon,
        shieldLock: MediumShieldLockIcon,
        shoppingCart: MediumShoppingCartIcon,
        slash: MediumSlashIcon,
        sort: MediumSortIcon,
        star: MediumStarIcon,
        stopwatch: MediumStopwatchIcon,
        student: MediumStudentIcon,
        sun: MediumSunIcon,
        table: MediumTableIcon,
        tag: MediumTagIcon,
        tags: MediumTagsIcon,
        thumbsUp: MediumThumbsUpIcon,
        tool: MediumToolIcon,
        tools: MediumToolsIcon,
        trash: MediumTrashIcon,
        trending: MediumTrendingIcon,
        trophy: MediumTrophyIcon,
        truck: MediumTruckIcon,
        upload: MediumUploadIcon,
        user2: MediumUser2Icon,
        user3: MediumUser3Icon,
        userPlus: MediumUserPlusIcon,
        user: MediumUserIcon,
        usersDocument: MediumUsersDocumentIcon,
        users: MediumUsersIcon,
        video: MediumVideoIcon,
        voice: MediumVoiceIcon,
        wallet: MediumWalletIcon,
        weight: MediumWeightIcon,
        windowClock: MediumWindowClockIcon,
        windowUser: MediumWindowUserIcon,
    },
    small: {
        alarmClock: SmallAlarmClockIcon,
        bankCard: SmallBankCardIcon,
        bank: SmallBankIcon,
        bed: SmallBedIcon,
        bellOff: SmallBellOffIcon,
        bell: SmallBellIcon,
        bone: SmallBoneIcon,
        book: SmallBookIcon,
        box: SmallBoxIcon,
        briefcase: SmallBriefcaseIcon,
        buildings: SmallBuildingsIcon,
        calculator: SmallCalculatorIcon,
        calendar2: SmallCalendar2Icon,
        calendarAlarmClock: SmallCalendarAlarmClockIcon,
        calendarArrowLeft: SmallCalendarArrowLeftIcon,
        calendarArrowRight: SmallCalendarArrowRightIcon,
        calendarCheck: SmallCalendarCheckIcon,
        calendarClock2: SmallCalendarClock2Icon,
        calendarClock3: SmallCalendarClock3Icon,
        calendarClock: SmallCalendarClockIcon,
        calendarDollar: SmallCalendarDollarIcon,
        calendarMinus: SmallCalendarMinusIcon,
        calendarPlus: SmallCalendarPlusIcon,
        calendarRefresh: SmallCalendarRefreshIcon,
        calendar: SmallCalendarIcon,
        calendars: SmallCalendarsIcon,
        camera: SmallCameraIcon,
        cap: SmallCapIcon,
        car: SmallCarIcon,
        cardReader: SmallCardReaderIcon,
        cards: SmallCardsIcon,
        checkmark: SmallCheckmarkIcon,
        chevronDown: SmallChevronDownIcon,
        chevronLeft: SmallChevronLeftIcon,
        chevronRight: SmallChevronRightIcon,
        chevronUp: SmallChevronUpIcon,
        chevronsDown: SmallChevronsDownIcon,
        clipboard: SmallClipboardIcon,
        clockLock: SmallClockLockIcon,
        clock: SmallClockIcon,
        close2: SmallClose2Icon,
        close: SmallCloseIcon,
        cog: SmallCogIcon,
        coins2: SmallCoins2Icon,
        coins3: SmallCoins3Icon,
        coinsHand: SmallCoinsHandIcon,
        coins: SmallCoinsIcon,
        computerCheckmark: SmallComputerCheckmarkIcon,
        computerClock: SmallComputerClockIcon,
        computerDollar: SmallComputerDollarIcon,
        computerMessage: SmallComputerMessageIcon,
        copy: SmallCopyIcon,
        cornerUpRight: SmallCornerUpRightIcon,
        crown: SmallCrownIcon,
        diamond: SmallDiamondIcon,
        discount: SmallDiscountIcon,
        document2: SmallDocument2Icon,
        documentClock: SmallDocumentClockIcon,
        documentLock: SmallDocumentLockIcon,
        documentPen: SmallDocumentPenIcon,
        dollar2: SmallDollar2Icon,
        dollar3: SmallDollar3Icon,
        dollar4: SmallDollar4Icon,
        dollar5: SmallDollar5Icon,
        dollar6: SmallDollar6Icon,
        dollar7: SmallDollar7Icon,
        dollar9: SmallDollar9Icon,
        dollar: SmallDollarIcon,
        drag: SmallDragIcon,
        dropbox: SmallDropboxIcon,
        employeeCard: SmallEmployeeCardIcon,
        envelopeClock: SmallEnvelopeClockIcon,
        envelope: SmallEnvelopeIcon,
        exclamation: SmallExclamationIcon,
        externalLink: SmallExternalLinkIcon,
        eyeOff: SmallEyeOffIcon,
        eye: SmallEyeIcon,
        faceFrown: SmallFaceFrownIcon,
        faceSmile: SmallFaceSmileIcon,
        field2: SmallField2Icon,
        field: SmallFieldIcon,
        file: SmallFileIcon,
        filter: SmallFilterIcon,
        flag: SmallFlagIcon,
        floppyDisk: SmallFloppyDiskIcon,
        folderPen: SmallFolderPenIcon,
        folder: SmallFolderIcon,
        form2: SmallForm2Icon,
        form: SmallFormIcon,
        gift: SmallGiftIcon,
        globe2: SmallGlobe2Icon,
        globeClock: SmallGlobeClockIcon,
        globe: SmallGlobeIcon,
        googleDrive: SmallGoogleDriveIcon,
        google: SmallGoogleIcon,
        graph2: SmallGraph2Icon,
        graph: SmallGraphIcon,
        grid2: SmallGrid2Icon,
        grid: SmallGridIcon,
        hand: SmallHandIcon,
        hash: SmallHashIcon,
        home: SmallHomeIcon,
        horse: SmallHorseIcon,
        image: SmallImageIcon,
        info: SmallInfoIcon,
        instagram1: SmallInstagram1Icon,
        instagram: SmallInstagramIcon,
        layers: SmallLayersIcon,
        library: SmallLibraryIcon,
        link: SmallLinkIcon,
        list2: SmallList2Icon,
        list3: SmallList3Icon,
        listPlus: SmallListPlusIcon,
        list: SmallListIcon,
        location: SmallLocationIcon,
        logOut: SmallLogOutIcon,
        magnifier: SmallMagnifierIcon,
        markerPin: SmallMarkerPinIcon,
        megaphone: SmallMegaphoneIcon,
        messageArrowUp: SmallMessageArrowUpIcon,
        messageCheckmark: SmallMessageCheckmarkIcon,
        messageClock: SmallMessageClockIcon,
        message: SmallMessageIcon,
        messages: SmallMessagesIcon,
        money2: SmallMoney2Icon,
        moneyAlarmClock: SmallMoneyAlarmClockIcon,
        money: SmallMoneyIcon,
        monitor: SmallMonitorIcon,
        moon: SmallMoonIcon,
        moreHorizontal: SmallMoreHorizontalIcon,
        note: SmallNoteIcon,
        notepadCheckmark: SmallNotepadCheckmarkIcon,
        notepadCheckmarks: SmallNotepadCheckmarksIcon,
        notepad: SmallNotepadIcon,
        package2: SmallPackage2Icon,
        package: SmallPackageIcon,
        palette: SmallPaletteIcon,
        paperclip: SmallPaperclipIcon,
        pen2: SmallPen2Icon,
        pen: SmallPenIcon,
        pencil: SmallPencilIcon,
        percent: SmallPercentIcon,
        percentage2: SmallPercentage2Icon,
        percentage3: SmallPercentage3Icon,
        percentage4: SmallPercentage4Icon,
        percentage: SmallPercentageIcon,
        phone2: SmallPhone2Icon,
        phoneArrowDown: SmallPhoneArrowDownIcon,
        phoneArrowUp: SmallPhoneArrowUpIcon,
        phoneIncoming: SmallPhoneIncomingIcon,
        phoneMissed: SmallPhoneMissedIcon,
        phoneOutgoing: SmallPhoneOutgoingIcon,
        phone: SmallPhoneIcon,
        pie: SmallPieIcon,
        pin: SmallPinIcon,
        plus: SmallPlusIcon,
        pocketsuite: SmallPocketsuiteIcon,
        questionMark: SmallQuestionMarkIcon,
        receipt: SmallReceiptIcon,
        refresh: SmallRefreshIcon,
        repeat: SmallRepeatIcon,
        rocket: SmallRocketIcon,
        safe: SmallSafeIcon,
        settings: SmallSettingsIcon,
        share: SmallShareIcon,
        shieldLock: SmallShieldLockIcon,
        shoppingCart: SmallShoppingCartIcon,
        slash: SmallSlashIcon,
        sort: SmallSortIcon,
        star: SmallStarIcon,
        stopwatch: SmallStopwatchIcon,
        student: SmallStudentIcon,
        sun: SmallSunIcon,
        table: SmallTableIcon,
        tag: SmallTagIcon,
        tags: SmallTagsIcon,
        thumbsUp: SmallThumbsUpIcon,
        tool: SmallToolIcon,
        tools: SmallToolsIcon,
        trash: SmallTrashIcon,
        trending: SmallTrendingIcon,
        trophy: SmallTrophyIcon,
        truck: SmallTruckIcon,
        upload: SmallUploadIcon,
        user2: SmallUser2Icon,
        user3: SmallUser3Icon,
        userPlus: SmallUserPlusIcon,
        user: SmallUserIcon,
        usersDocument: SmallUsersDocumentIcon,
        users: SmallUsersIcon,
        video: SmallVideoIcon,
        voice: SmallVoiceIcon,
        wallet: SmallWalletIcon,
        weight: SmallWeightIcon,
        windowClock: SmallWindowClockIcon,
        windowUser: SmallWindowUserIcon,
    },
    payment: {
        amex: PaymentAmexIcon,
        applePay: PaymentApplePayIcon,
        discover: PaymentDiscoverIcon,
        mastercard: PaymentMastercardIcon,
        visa: PaymentVisaIcon,
    },
}
